global.$ = global.jQuery = require('jquery');

import "./jquery";
import "./jquery.scrollTo.min";
import "./slick/slick";
import "./functions";
import "./isotope/jquery.smartresize"
// import "./isotope/dragger"
// import "./isotope/isotope.pkgd.min";
// import "../../node_modules/isotope-layout/js/isotope";